<footer id="contact" class="position-relative overflow-hidden pb-0">
  <img src="assets/images/demo-freelancer-03.png" class="position-absolute top-0px right-minus-100px" alt="">
  <div class="container position-relative">
    <img src="assets/images/demo-freelancer-04.png" class="position-absolute top-20px right-minus-100px d-none d-md-block" alt="">
    <div class="row">
      <div class="col-md-12 position-relative">
        <div class="fs-70 md-fs-50 sm-fs-40 ls-minus-3px fw-700 text-black mb-10px sm-ls-minus-1px">Create something great.</div>
        <div class="d-flex align-items-center">
          <i class="bi bi-envelope icon-extra-large md-icon-large me-10px text-base-color align-middle"></i>
          <a href="mailto:info&#64;veeduplan.in" class="fs-50 sm-fs-40 text-base-color fw-600 align-middle ls-minus-3px sm-ls-minus-1px">info&#64;veeduplan.in</a>
        </div>
      </div>
    </div>
    <div class="row g-0 align-items-center border-top border-2 border-color-dark-gray pt-30px mt-6 mb-3">
      <div class="col-md-7 last-paragraph-no-margin sm-mb-20px">
        <p>Veeduplan is a brand of Almino Structural Consultancy Pvt Ltd.</p>
      </div>
      <div class="col-md-5 elements-social social-text-style-01 text-start text-md-end sm-mb-20px">
        <ul class="medium-icon dark fw-600">
          <li><a class="facebook" href="https://facebook.com/veeduplan" target="_blank"><i class="fab fa-facebook-f" style="color: #000;"></i></a></li>
          <li><a class="instagram" href="https://instagram.com/veeduplan" target="_blank"><i class="fab fa-instagram" style="color: #000;"></i></a></li>
          <li><a class="twitter" href="#" target="_blank"><i class="fab fa-twitter" style="color: #000;"></i></a></li>
          <li><a class="linkedin" href="#" target="_blank"><i class="fab fa-linkedin-in" style="color: #000;"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>

